import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { ExternalLink } from '../../../common/ExternalLink'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { Panel } from '../../../common/panel'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { formatText } from '../../../helpers/value'
import { LabelPanel } from '../common/LabelPanel'
import { RightPanel } from '../common/RightPanel'
import { SENTIMENT_TYPE_COLOR, SENTIMENT_TYPE_ID } from '../constant'
import classes from './index.module.scss'

export const News = ({ data, detailKey }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()

  const detailData = data[detailKey]

  const getIconName = () => {
    switch (detailData?.sentimentId) {
      case SENTIMENT_TYPE_ID.POSITIVE:
        return 'icon-plus-circle-fill'
      case SENTIMENT_TYPE_ID.NEGATIVE:
        return 'icon-remove-circle'
      case SENTIMENT_TYPE_ID.NEUTRAL:
        return 'icon-circle'
      default:
        return ''
    }
  }

  return (
    <Panel
      renderLabel={() => <LabelPanel data={data} detailData={detailData} />}
      renderRightHeader={() => <RightPanel data={data} detailKey={detailKey} />}
    >
      <Element className={classes.description} style={{ fontSize: 14 }}>
        {formatText(detailData?.headline)}
      </Element>
      <Element className={classes.content} style={{ color: '#3A414B' }}>
        <Element className="dFlex alignItemsCenter fw600">
          <Translate value="alertDetail.SENTIMENT" />
          :&nbsp;&nbsp;
          <span
            className="dFlex alignItemsEnd"
            style={{ color: SENTIMENT_TYPE_COLOR[detailData?.newsSentimentId] }}
          >
            <Icon className={getIconName()} style={{ fontSize: 13 }} />
            &nbsp;
            <span>{detailData?.newsTypeName}</span>
          </span>
        </Element>
        <Element className="dFlex alignItemsCenter">
          <Translate value="alertDetail.SOURCE" className="fw600" />
          :&nbsp;
          <span>{formatText(detailData?.source)}</span>
        </Element>
        <div>
          <Translate value="alertDetail.PUBLICATION_DATE" className="fw600" />
          :&nbsp;
          <span>
            {formatDateTime(
              detailData?.publicDate,
              FORMAT.DATE,
              locale,
              timezone,
            )}
          </span>
        </div>
        {detailData?.contents && (
          <div
            className="mt1"
            dangerouslySetInnerHTML={{ __html: detailData?.contents }}
          />
        )}
        <div className="textEnd mt1">
          <ExternalLink href={detailData?.sourceLink}>
            <Translate value="alertDetail.LINK_ARTICLE" />
          </ExternalLink>
        </div>
      </Element>
    </Panel>
  )
}
